import * as Icons from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { CATEGORIES, WHY } from "@/lib/content";

const Icon = ({ name, className }) => {
  const C = Icons[name] || Icons.Circle;
  return <C className={className} />;
};

export const Categories = () => {
  return (
    <section id="categories" className="py-[35px] lg:py-[50px] bg-[#FFFFFF]" data-testid="categories-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 -ml-[5px]">
          <SectionHeading
            align="left"
            eyebrow="Product Categories"
            title="What You'll Find"
          />
        </div>

        <div className="mt-[34px] lg:mt-14 grid sm:grid-cols-2 gap-5 lg:gap-6">
          {CATEGORIES.map((c, i) => (
            <Reveal key={c.title} delay={(i % 2) * 0.1}>
              <div
                data-testid={`category-${i}`}
                className="group relative flex h-full min-h-[132px] items-center rounded-[18px] bg-[#F1F1F3]"
              >
                <div className="relative z-10 w-[54%] sm:w-[44%] pl-[24.5px] sm:pl-[40px] pr-2 py-[18px]">
                  <h3 className="font-heading text-lg sm:text-xl font-bold text-[#1A1A1A] leading-tight">
                    {c.title}
                  </h3>
                  <p className="font-body text-sm text-[#5A5A55] mt-2 leading-snug">
                    {c.desc.split("|").map((part, idx, arr) => (
                      <span key={idx}>
                        {part}
                        {idx < arr.length - 1 && <br className="sm:hidden" />}
                        {idx < arr.length - 1 && <span className="hidden sm:inline"> </span>}
                      </span>
                    ))}
                  </p>
                </div>
                <div className="absolute right-0 top-0 h-full w-[58%] flex items-center justify-center pr-2 sm:pr-5">
                  <div className="relative flex items-end justify-center">
                    <img
                      src={c.image}
                      alt={c.title}
                      className={`relative max-h-[123px] sm:max-h-[178px] w-auto object-contain ${
                        c.title === "Home Essentials"
                          ? "-translate-y-2.5"
                          : c.title === "Household Goods"
                          ? "translate-x-3 sm:translate-x-0"
                          : ""
                      }`}
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 flex justify-center">
          <a
            href="#contact"
            data-testid="request-catalog-cta"
            className="group inline-flex items-center justify-center gap-2 rounded-[5px] bg-[#F8B808] px-[23px] h-10 font-body text-base font-medium text-[#1A1A1A] transition-all hover:bg-[#DD9F00] active:scale-[0.98]"
          >
            Request Catalog
          </a>
        </div>
      </div>
    </section>
  );
};

export const WhyCustomers = () => {
  return (
    <section className="py-[35px] lg:py-[50px] bg-white" data-testid="why-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          eyebrow="Why Customers Return"
          title="Loved by value-conscious shoppers"
        />
        <div className="mt-[34px] lg:mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {WHY.map((w, i) => (
            <Reveal key={w.title} delay={i * 0.1}>
              <div
                data-testid={`why-${i}`}
                className="h-full rounded-[18px] bg-white border border-[#E5E5E5] px-7 py-6"
              >
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#FBF4DD]">
                  <Icon name={w.icon} className="h-4 w-4 text-[#1A1A1A]" />
                </span>
                <h3 className="font-heading text-base font-bold text-[#1A1A1A] mt-4">
                  {w.title}
                </h3>
                <p className="font-body text-sm text-[#6B6B66] mt-1 leading-relaxed">
                  {w.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
